// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"2901dc11","453":"0f825ed2","732":"96e1a924","977":"113ecc81"}[chunkId] + ".chunk.js");